module.exports = __webpack_public_path__ + "static/media/pencil.586d4d87.png";